package com.essntl.features.itinerary.ui.edit_itinerary_service.components

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import com.essntl.core.utils.utils.capitalizeFirstLetter
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.itinerary.domain.model.DynamicField
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.spacing

@Composable
fun DynamicFields(
    category: CategoryModel?,
    itineraryService: ItineraryServiceModel,
    onItineraryServiceChange: (ItineraryServiceModel) -> Unit,
) {
    category?.dynamicFields?.map { d ->
        Spacer(modifier = Modifier.height(height = 1.5.spacing))

        EsInput(
            value = itineraryService.dynamicFields
                ?.firstOrNull { it.fieldName == d.fieldName }?.value
                .orEmpty(),
            onValueChange = { v ->
                val mutableList = itineraryService.dynamicFields?.toMutableList() ?: mutableListOf()

                val index = mutableList.indexOfFirst { it.fieldName == d.fieldName }

                if (index != -1)
                    mutableList[index] = DynamicField(d.fieldName, v, d.showOnItinerary)
                else
                    mutableList.add(DynamicField(d.fieldName, v, d.showOnItinerary))

                onItineraryServiceChange(
                    itineraryService.copy(
                        dynamicFields = mutableList,
                    ),
                )
            },
            placeholder = "Enter ${d.fieldName.capitalizeFirstLetter()}",
            label = d.fieldName.capitalizeFirstLetter(),
            modifier = Modifier.fillMaxWidth(),
        )
    }
}